import styles from './index.less';
import Detail from '@/pages/RepairDetail/components/Detail';
import { repairDetailItem } from '@/pages/RepairManage/config';
import { useModel } from '@umijs/max';
import RepairSteps from '@/pages/RepairDetail/components/RepairSteps';

const RepairDetail = () => {
  const { editClick, refreshSend } = useModel('useRepair', (model) => ({
    editClick: model.editClick,
    refreshSend: model.refreshSend,
  }));

  const handleCancelClick = () => {
    console.log('cancelClick');
  };

  return (
    <div className={styles.container}>
      <RepairSteps status={repairDetailItem.status} />

      <Detail
        detailItems={repairDetailItem}
        editClick={editClick}
        cancelClick={handleCancelClick}
        refreshSendClick={refreshSend}
      />
    </div>
  );
};

export default RepairDetail;
